import styled from 'styled-components';

export const Container = styled.div`
  .contents-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 14px;
  }

  .filters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 18px;
  }

  .filter-pill {
    background: #f1f1f1;
    border: 1px solid #ced4da;
    color: #000;
    font-size: 0.9rem;
    font-weight: 700;
    padding: 6px 18px;
    border-radius: 50px;
    cursor: pointer;
  }

  .filter-pill:hover {
    background: #e2e2e2;
  }

  .filter-pill.active {
    background: #3d3d3d;
    border-color: #292929;
    color: #fff;
  }

  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .pagination-wrapper button {
    min-width: 32px;
    height: 32px;
    border: 1px solid #dee2e6;
    background: #fff;
    color: #6c757d;
    font-size: 0.9rem;
    margin-left: -1px;
    cursor: pointer;
  }

  .pagination-wrapper button:first-child {
    border-radius: 4px 0 0 4px;
  }

  .pagination-wrapper button:last-child {
    border-radius: 0 4px 4px 0;
  }

  .pagination-wrapper button.active {
    background: #007bff;
    border-color: #007bff;
    color: #fff;
  }

  .pagination-wrapper button:disabled {
    color: #c0c4cc;
    cursor: default;
  }

  .empty-state {
    text-align: center;
    color: #888;
    padding: 60px 20px;
  }

  .empty-state .material-icons {
    font-size: 56px;
    color: #ccc;
    margin-bottom: 12px;
  }

  .loading-wrapper {
    display: flex;
    justify-content: center;
    padding: 60px 0;
  }
`;
